import { boolean, type ObjectSchema, string, object } from 'yup';

import type { Address } from '@/types/person';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

const ADDRESS_MAX_LENGTH = 26;

export const addressesSchema: ObjectSchema<
  Omit<Address, 'address_type' | 'delivery_point_barcode' | 'dpv_match_code'>
> = object().shape({
  address1: string()
    .trim()
    .optional()
    .nullable()
    .max(ADDRESS_MAX_LENGTH)
    .label('Address - Line 1')
    .transform(transformEmptyStringToNull),
  address2: string()
    .trim()
    .optional()
    .nullable()
    .max(ADDRESS_MAX_LENGTH)
    .label('Address - Line 2')
    .transform(transformEmptyStringToNull),
  address_type_id: string()
    .trim()
    .optional()
    .nullable()
    .label('Address Type')
    .transform(transformEmptyStringToNull),
  city: string().trim().optional().nullable().label('City').transform(transformEmptyStringToNull),
  country: string().trim().required(),
  default: boolean().required().label('Default'),
  first_name: string()
    .trim()
    .optional()
    .nullable()
    .label('First name')
    .transform(transformEmptyStringToNull),
  id: string().optional().label('Address id'),
  last_name: string()
    .trim()
    .optional()
    .nullable()
    .label('Last name')
    .transform(transformEmptyStringToNull),
  mailing_instructions: string()
    .trim()
    .optional()
    .nullable()
    .label('Mailing instructions')
    .transform(transformEmptyStringToNull),
  person_id: string().trim().optional().label('Address person id'),
  postal_code: string()
    .trim()
    .min(5)
    .max(10)
    .matches(/^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/, {
      message: 'Postal code is not valid',
      excludeEmptyString: true
    })
    .optional()
    .label('Postal code'),
  state: string().trim().required().label('State')
});
